<template>
    <div class="project">
        <nav class="nav-container">
            <headers></headers>
            <div class="nav-tabs">
                <div class="Logo-container">
                    <div class="Logo">
                        <div>
                            <img style="width: 40px;" :src="navItems[0].link" alt="">
                        </div>
                        <div>
                            {{ navItems[0].name }}
                        </div>
                    </div>
                </div>
                <div class="nav-items-group">
                    <div @mouseover="dropDownChange(item)" v-for="item in navItems" :key="item.name"
                        v-show="item.name !== '遵农共享'">
                        <div @click="Active(item)" class="nav-item" :class="{ 'active': activeNav === item.name }"
                            v-if="item.name === 'sustainableDevelopment' || item.name === 'home'">
                            {{ $t(`navItems.${item.name}`) }}
                        </div>
                        <el-dropdown @command="handleCommand" v-else trigger="hover" class="nav-item"
                            :class="{ 'active': activeNav === item.name }">
                            <div>
                                {{ $t(`navItems.${item.name}`) }}
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="subItem" class="dropdown-item" v-for="subItem in downList"
                                    :key="subItem.label">{{ $t(`downlist.${subItem.label}`)
                                    }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </nav>

        <!-- 天方圆 -->
        <div v-show="tianfang" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title1') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="tianfangyuan" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content1') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in list" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 亚滦湾 -->
        <div v-show="yaluan" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title2') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="yaluanwans" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content2') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in yaluanwan" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 企业生鲜 -->
        <div v-show="qiyeshengxian" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title3') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="shengxian_LOGO" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content3') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in qiye" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 个人生鲜 -->
        <div v-show="gerenflag" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title4') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="geren_LOGO" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content4') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in geren" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 诚采云仓 -->
        <div v-show="chengcaiflag" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title5') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="chengcaiyuncang" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content5') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in chengcai" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 微官网 -->
        <div v-show="weiguanwangflag" class="project-section">
            <div class="project-content">
                <!-- 标题区域 -->
                <div class="project-content-title">
                    {{ $t('project.title6') }}
                </div>

                <!-- 主图展示区 -->
                <div class="project-main-image">
                    <img :src="glw" style="object-fit: contain;" alt="" class="main-img">
                </div>
                <div>
                    {{ $t('project.content6') }}
                </div>
                <!-- 子图列表区 -->
                <div class="project-gallery">
                    <div class="gallery-item" v-for="item in weiguanwang" :key="item.name">
                        <div class="gallery-img-container">
                            <img :src="item.link" alt="" class="gallery-img">
                        </div>
                        <div class="gallery-caption">
                            {{ $t(`project.${item.name}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import glw from '../images/nyj-logo.jpg';
import weiguanwang from '../images/weiguanwang.png';
import weiguanwang2 from '../images/weiguanwang2.png';
import weiguanwang3 from '../images/weiguanwang3.png';
import weiguanwang4 from '../images/weiguanwang4.png';

import chengcai1 from '../images/chengcai1.png';
import chengcai2 from '../images/chengcai2.png';
import chengcai3 from '../images/chengcai3.png';
import chengcai4 from '../images/chengcai4.png';
import chengcaiyuncang from '../images/chengcaiyuncang.jpg';
import tianfangyuan from '../images/tianfangyuan.jpg';
import yaluanwans from '../images/yaluanwan.jpg';
import yaluanwan1 from '../images/yaluanwan.png';
import yaluanwan2 from '../images/yaluanwan2.png';
import yaluanwan3 from '../images/yaluanwan3.png';
import yaluanwan4 from '../images/yaluanwan4.png';
import logo from '../images/nyj-logo.jpg';
import headers from '@/components/header/headers';
import tianfangyuansucai1 from '../images/tianfangyuansucai1.png';
import tianfangyuansucai2 from '../images/tianfangyuansucai2.png';
import tianfangyuansucai3 from '../images/tianfangyuansucai3.png';
import tianfangyuansucai4 from '../images/tianfangyuansucai4.png';
import qiye from '../images/qiye.png';
import qiye2 from '../images/qiye2.jpg';
import qiye3 from '../images/qiye3.png';
import qiye4 from '../images/qiye4.png';
import shengxian from '../images/shengxian_LOGO.png';
import geren_LOGO from '../images/geren_LOGO.png';
import gerenshengxian from '../images/gerenshengxian.jpg';
import fujin from '../images/fujin.png';
import fenlei from '../images/fenlei.jpg';
import gouwuche from '../images/gouwuche.png';
import gerenzhongxin from '../images/gerenzhongxin.png';
export default {
    name: 'Project',
    components: { headers },
    data() {
        return {
            weiguanwangflag: false,
            weiguanwang: [
                { name: 'name22', link: weiguanwang },
                { name: 'name23', link: weiguanwang2 },
                { name: 'name24', link: weiguanwang3 },
                { name: 'name25', link: weiguanwang4 },
            ],
            chengcaiyuncangflag: false,
            chengcaiyuncang: chengcaiyuncang,
            chengcai: [
                { name: 'name18', link: chengcai1 },
                { name: 'name19', link: chengcai2 },
                { name: 'name20', link: chengcai3 },
                { name: 'name21', link: chengcai4 },
            ],
            gerenflag: false,
            geren: [
                { name: 'name13', link: gerenshengxian },
                { name: 'name14', link: fujin },
                { name: 'name15', link: fenlei },
                { name: 'name16', link: gouwuche },
                { name: 'name17', link: gerenzhongxin },
            ],
            geren_LOGO: geren_LOGO,
            qiye: [
                { name: 'name9', link: qiye },
                { name: 'name10', link: qiye2 },
                { name: 'name11', link: qiye3 },
                { name: 'name12', link: qiye4 },
            ],
            active: '',
            qiyeshengxian: false,
            tianfang: false,
            yaluan: false,
            shengxian_LOGO: shengxian,
            yaluanwans: yaluanwans,
            tianfangyuan: tianfangyuan,
            list: [
                { name: 'name1', link: tianfangyuansucai1 },
                { name: 'name2', link: tianfangyuansucai2 },
                { name: 'name3', link: tianfangyuansucai3 },
                { name: 'name4', link: tianfangyuansucai4 },
            ],
            yaluanwan: [
                { name: 'name5', link: yaluanwan1 },
                { name: 'name6', link: yaluanwan2 },
                { name: 'name7', link: yaluanwan3 },
                { name: 'name8', link: yaluanwan4 },
            ],
            downList: [],
            glw: glw,
            navItems: [
                { name: "遵农共享", link: logo },
                { name: 'home' },
                { name: "aboutUs" },
                { name: "products" },
                { name: "sustainableDevelopment" },
                { name: "joinUs" }
            ],
            activeNav: 'products',
        }
    },
    methods: {
        handleCommand(item) {
            console.log(item);
            if (item.label === 'label1') {
                this.$router.push({ path: 'about', query: { active: 'label1' } });
            } else if (item.label === 'label2') {
                this.$router.push({ path: 'about', query: { active: 'label2' } });
            } else if (item.label === 'label3') {
                this.$router.push({ path: 'about', query: { active: 'label3' } });
            } else if (item.label === 'label4') {
                this.yaluan = false;
                this.tianfang = true;
                this.qiyeshengxian = false;
                this.gerenflag = false;
                this.chengcaiflag = false;
                this.weiguanwangflag = false;


            } else if (item.label === 'label5') {
                this.yaluan = true;
                this.tianfang = false;
                this.qiyeshengxian = false;
                this.gerenflag = false;
                this.chengcaiflag = false;
                this.weiguanwangflag = false;


            } else if (item.label === 'label6') {
                this.yaluan = false;
                this.tianfang = false;
                this.qiyeshengxian = true;
                this.gerenflag = false;
                this.chengcaiflag = false;
                this.weiguanwangflag = false;


            } else if (item.label === 'label7') {
                this.yaluan = false;
                this.tianfang = false;
                this.qiyeshengxian = false;
                this.chengcaiflag = false;
                this.gerenflag = true;
                this.weiguanwangflag = false;

            } else if (item.label === 'label9') {
                this.chengcaiflag = true;
                this.yaluan = false;
                this.tianfang = false;
                this.qiyeshengxian = false;
                this.gerenflag = false;
                this.weiguanwangflag = false;

            } else if (item.label === 'label8') {
                this.weiguanwangflag = true;
                this.yaluan = false;
                this.tianfang = false;
                this.qiyeshengxian = false;
                this.gerenflag = false;
                this.chengcaiflag = false;
            }else if (item.label === 'label10') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label10' } });
            }else if (item.label === 'label11') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label11' } });
            }
        },
        // 下拉菜单切换
        dropDownChange(item) {
            this.downList = [];
            if (item.name === 'aboutUs') {
                this.downList = [{ label: 'label1' }, { label: 'label2' }, { label: 'label3' }];
            } else if (item.name === 'products') {
                this.downList = [{ label: 'label4' }, { label: 'label5' }, { label: 'label6' }, { label: 'label7' }, { label: 'label8' }, { label: 'label9' }];
            } else if (item.name === 'joinUs') {
                this.downList = [{ label: 'label10' }, { label: 'label11' }];
            }
        },
        // 导航激活
        Active(item) {
            this.activeNav = item.name;
            console.log(item.name);
            if (item.name === 'home') {
                this.$router.push({ path: 'HomePage' });
            } else if (item.name === 'aboutUs') {
                this.$router.push({ path: 'about', query: { active: 'label1' } });
            } else if (item.name === 'sustainableDevelopment') {
                this.$router.push({ path: 'development' });
            } else if (item.name === 'joinUs') {
                this.$router.push({ path: 'joinUs' });
            }
        }
    },
    created() {
        this.active = this.$route.query.active;
        this.tianfang = false;
        this.yaluan = false;
        this.qiyeshengxian = false;
        this.gerenflag = false;
        this.chengcaiflag = false;
        this.weiguanwangflag = false;

        // 第二步：单独激活当前 active 对应的 flag
        switch (this.active) {
            case 'label4':
                this.tianfang = true;
                break;
            case 'label5':
                this.yaluan = true;
                break;
            case 'label6':
                this.qiyeshengxian = true;
                break;
            case 'label7':
                this.gerenflag = true;
                break;
            case 'label8':
                this.weiguanwangflag = true;
                break;
            case 'label9':
                this.chengcaiflag = true;
                break;

            default:
                break;
        }
    }
}
</script>
<style scoped>
.project-section {
    padding: 2.5em 1.5em;
    max-width: 1200px;
    margin: 0 auto;
}

/* 内容容器 */
.project-content {
    display: flex;
    flex-direction: column;
    gap: 2em;
    align-items: center;
}

/* 标题样式 */
.project-content-title {
    font-size: 1.875em;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 1em;
    position: relative;
    padding-bottom: 0.75em;
}


/* 主图样式 */
.project-main-image {
    width: 100%;
    max-width: 35em;
    aspect-ratio: 1/1;
    border-radius: 12px;
    overflow: hidden;

    transition: transform 0.3s ease;
}



.main-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.main-img:hover {
    opacity: 0.95;
}

/* 子图画廊样式 */
.project-gallery {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 2em;
    flex-wrap: wrap;
    padding: 1em 0;
}

.gallery-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75em;
    width: 7em;
    transition: transform 0.3s ease;
}

.gallery-item:hover {
    transform: translateY(-5px);
}

/* 子图容器 */
.gallery-img-container {
    width: 100%;
    height: 15em;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #f7fafc;
}

.gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.gallery-item:hover .gallery-img {
    transform: scale(1.03);
    opacity: 0.95;
}

/* 子图标题 */
.gallery-caption {
    font-size: 0.9375em;
    color: #4a5568;
    text-align: center;
    padding: 0 0.5em;
    line-height: 1.4;
    font-weight: 500;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .project-section {
        padding: 1.5em 1em;
    }

    .project-content-title {
        font-size: 1.5em;
    }

    .project-main-image {
        max-width: 100%;
        height: auto;
    }

    .project-gallery {
        gap: 1.5em;
        justify-content: center;
    }

    .gallery-item {
        width: 6em;
    }

    .gallery-img-container {
        height: 12em;
    }
}

@media (max-width: 480px) {
    .project-gallery {
        gap: 1em;
    }

    .gallery-item {
        width: 5em;
    }

    .gallery-img-container {
        height: 10em;
    }

    .gallery-caption {
        font-size: 0.875em;
    }
}

.project-content-title {

    text-align: center;
    color: var(--glwColor);
    font-size: 4.2em;
    font-family: 'Courier New', Courier, monospace;

}

.dropdown-item:hover {
    color: #46B135;
    background-color: rgba(70, 177, 53, 0.1);
}

.nav-container {
    position: sticky;
    top: 0;
    width: 100%;
    box-shadow: 0 2px 4px rgba(var(--glwColorRgb), 0.1);
    padding: 0 1em;
    background: #fff;
    z-index: 999;
    box-sizing: border-box;
}

.Logo {
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-weight: bold;
}

.nav-tabs {
    margin: 0 auto;
    width: 100%;
    max-width: 1500px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2em;
    cursor: pointer;
}

.nav-items-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2em;
    flex: 1;
}

.nav-item {
    text-align: center;
    min-width: 5em;
    font-size: 1em;
    position: relative;
    display: inline-block;
    padding: 0.8em 0;
    line-height: 1.2;
    box-sizing: border-box;
    transition: color 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--glwColor);
    transition: width 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
    color: var(--glwColor);
}

.project {
    --glwColor: #46B135;
    --glwColorRgb: 70, 177, 53;
    font-size: 16px;
}

@media screen and (max-width: 1500px) {
    .about-page {
        font-size: 16px;
    }
}

@media screen and (max-width: 1200px) {
    .about-page {
        font-size: 14px;
    }
}

@media screen and (max-width: 768px) {
    .about-page {
        font-size: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/project.vue